module.exports = __webpack_public_path__ + "static/aumento3-6984a42f701e1f967806b4c764240838.jpg";